import { ListboxOption } from '@reach/listbox';

import { IDropdownItem } from './types';

function DropdownItem({ className, children, value }: IDropdownItem) {
  return (
    <ListboxOption className={className} key={value} value={value}>
      {children}
    </ListboxOption>
  );
}

export default DropdownItem;
